import type {MotionProps, Variants} from 'framer-motion'

export const OpacityVariants: Variants = {
  invisible: {opacity: 0},
  visible: {opacity: 1},
}

export const FadeInOutAnimation = {
  variants: OpacityVariants,
  initial: 'invisible',
  animate: 'visible',
  exit: 'invisible',
} satisfies MotionProps
